import {useCallback} from 'react'
import {useQueryClient} from '@github-ui/react-query'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {useRespondToAliveUpdate, type PullRequestAliveContext} from './use-refetch-on-alive-update'
import {descriptionQueryKey, type DescriptionData} from '../page-data/loaders/use-description-data'

export function useDescriptionLiveUpdates(channel: string): void {
  const queryClient = useQueryClient()
  const descriptionURL = usePageDataUrl(PageData.description)

  const handler = useCallback(
    (context: PullRequestAliveContext | undefined) => {
      const queryKey = descriptionQueryKey(descriptionURL)
      // If the published body version matches what we already have cached
      // (e.g. because our own mutation primed the cache from the response),
      // there is nothing new to fetch.
      const publishedVersion = context?.description_body_version
      if (publishedVersion) {
        const cached = queryClient.getQueryData<DescriptionData>(queryKey)
        if (cached?.bodyVersion === publishedVersion) return
      }
      queryClient.refetchQueries({queryKey})
    },
    [queryClient, descriptionURL],
  )

  useRespondToAliveUpdate(channel, handler, {body_updated: true})
}
